import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import BudgetOperationTop from './BudgetOperationTop.js';
import ApiService from '../../services/ApiService.js';

const BudgetOperation = ReactRouterDOM.withRouter(function ({ match }) {
  const { setError } = useAppContext();
  const [budgetOperation, setBudgetOperation] = React.useState(null);

  React.useEffect(() => {
    fetchBudgetOperation();
  }, []);

  const fetchBudgetOperation = async function () {
    try {
      setBudgetOperation(await ApiService.getBudgetOperation(match.params.budgetOperationId));
    }
    catch (error) {
      setError(error);
      return;
    }
  }
  
  if (budgetOperation === null || budgetOperation === undefined) {
    return (
      <div />
    );
  }
  
  return (
    <div>
      {budgetOperation ? (
        <div className="p-1">
          <div className="border bg-light">
            <div className="p-2 fs-6">
              <BudgetOperationTop budgetOperation={budgetOperation} />
            </div>
          </div>
        </div>
      ) : null}
      <div className="d-flex flex-wrap">
        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
        </div>
      </div>
    </div>
  );
})

export default BudgetOperation;
